import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import { IconButton } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";
import type { Report } from "../../../../../../../../api/types/svTypes.ts";
import useClientContext from "../../../../../../../../context/useClientContext.ts";
import { useEnhancedBiApiClientProvider } from "../../../../contexts/ApiClientProviderContext";
import ReportActions from "./ReportActions";

interface Props {
  report: Report;
  readonlyMode?: boolean;
}

export default function MoreAction({ report, readonlyMode }: Props) {
  const navigate = useNavigate();
  const { clientCode } = useClientContext();
  const [openActionsMenu, setOpenActionsMenu] = React.useState(false);
  const [actionMenuRef, setActionMenuRef] = React.useState<HTMLElement | null>(null);
  const { getReportsUrl } = useEnhancedBiApiClientProvider();

  return (
    <>
      <IconButton key="action-button" ref={setActionMenuRef} onClick={() => setOpenActionsMenu(true)}>
        <MoreHorizOutlinedIcon />
      </IconButton>
      {openActionsMenu && (
        <ReportActions
          key={"actions"}
          anchorEl={actionMenuRef}
          report={report}
          onDeleted={() => navigate(getReportsUrl(clientCode))}
          onClose={() => setOpenActionsMenu(false)}
          readonlyMode={readonlyMode}
        />
      )}
    </>
  );
}
